import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from 'antd';
import ls from 'local-storage';
import API from "../../Services/BaseService";
import Loading from "../../Component/Loading/Loading";
import adduser from '../../assets/img/adduser.jpg';
import vehicles from '../../assets/img/vehicles.png';
import appstore from '../../assets/img/appstore.png';
import Pagination from "../Pagination";
import googleplay from '../../assets/img/googleplay.png';
import _ from 'lodash';
import PageNotFound from '../FallBackUI/PageNotFound';

const pageLimit = 10;


const SellerCharges = () => {

    const history = useHistory();
    const successData = useSelector(state => state.LoginReducer.payload);
    const [sellerChargeList, setSellerChargeList] = useState("");
    const [errors, setErrors] = useState("");
    const [errorFlag, setErrorFlag] = useState(false);
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState("");
    const [currentPage, setCurrentPage] = useState(ls.get("currentpageopen") || 1);
    const [searchFlag, setSearchFlag] = useState(false);
    const [searchFlag1, setSearchFlag1] = useState(false);
    const handlePages = (page) => {
        ls.set("currentpageopen", page)
        setCurrentPage(page)
        setSearchFlag1(true)
    }
    const [totalRecords, setTotalRecords] = useState(0);
    const [totalPages, setTotalPages] = useState(1);

    const [dealerId, setDealerId] = useState("");
    const [sellerId, setSellerId] = useState("");
    const [inventory, setInventory] = useState("");
    const [vinNumber, setVinNumber] = useState("");
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setSearchFlag1(true)
    };
    const backUrl = ls.get("backredirection");
    console.log("check the back url", backUrl);
    const back = backUrl[(backUrl.length) - 1];
    console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

    const [carSearchTriggered, setCarSearchTriggered] = useState(false);

    const handlePageChangeDebounced = _.debounce(() => {
        if (!searchFlag1 && !searchFlag) {
            getSellerCharge();
        }
        else if (searchFlag1 && searchFlag && !carSearchTriggered) {
            searchUser();
        } else if (searchFlag1 && !searchFlag) {
            getSellerCharge();
        }
    }, 300);

    useEffect(() => {
        if (searchFlag || searchFlag1) {
            setCarSearchTriggered(false);
        }
    }, [searchFlag, searchFlag1]);


    useEffect(() => {

        handlePageChangeDebounced();
        console.log("checking if in useEffect");
        return () => {
            handlePageChangeDebounced.cancel();
        };

    }, [currentPage, searchFlag]);


    // useEffect(() => {
    //     getSellerCharge();
    // }, [currentPage]);

    const getSellerCharge = () => {

        let request = {

            seller_id: successData.seller_id,
            seller_token: successData.seller_token,
        }


        API.post("sellerchargeslist/condition", request).then(response => {

            if (response.data.success === true) {

                // setSellerChargeList(response.data.data);
                const endIndex = currentPage * pageLimit;
                const startIndex = endIndex - pageLimit;
                const records = response.data.data.slice(startIndex, endIndex)
                setSellerChargeList(records);
                setTotalPages(Math.ceil(response.data.data.length / 10));
                setTotalRecords([...Array(Math.ceil(response.data.data.length / 10) + 1).keys()].slice(1))
                setLoading(false);
            }
            else {
                setErrors(response.data.error.name)
                setErrorFlag(true)
            }
        })
            .catch(function (error) {
                if (error.response) {
                    setErrors(error.response.data.error)
                    setErrorFlag(true)
                    setLoading(false);
                }
            });
    }

    const onHandleView = (item) => {
        history.push({
            pathname: "/viewsellercharges",
            state: { carChargesId: item.carcharges_detail_id }
        });
    }

    const handleData = (e) => {
        const value = e.target.value.replace(/[^\w\s]/gi, "");
        setData(value);
    };

    const searchUser = () => {

        let request = {

            vin_no: vinNumber,
            car_id: inventory,
            seller_dealer_id: dealerId,
            sellerid: sellerId,
            seller_id: successData.seller_id,
            seller_token: successData.seller_token,

        }
        API.post("sellerchargesSearch/condition", request).then(response => {

            // setSellerChargeList(response.data.data);
            // const endIndex = currentPage * pageLimit;
            // const startIndex = endIndex - pageLimit;
            // const records = response.data.data.slice(startIndex, endIndex)
            // setSellerChargeList(records);
            // setTotalPages(Math.ceil(response.data.data.length / 10));
            // setTotalRecords([...Array(Math.ceil(response.data.data.length / 10) + 1).keys()].slice(1))

            let filteredBuyerList = response.data.data;
            setSellerChargeList(filteredBuyerList);

            if (!vinNumber && !inventory && !dealerId && !sellerId) {
                setSearchFlag(false)
            }

            const totalCount = filteredBuyerList.length;
            const newTotalPages = Math.ceil(totalCount / pageLimit);
            let newCurrentPage = currentPage;
            if (newCurrentPage <= 0) {
                newCurrentPage = 1;
            } else if (newCurrentPage > newTotalPages) {
                newCurrentPage = newTotalPages;
            }
            setCurrentPage(newCurrentPage);

            const startIndex = (newCurrentPage - 1) * pageLimit;
            const endIndex = Math.min(currentPage * pageLimit, totalCount);

            // const startIndex = (currentPage - 1) * pageLimit;
            // const endIndex = startIndex + pageLimit;
            console.log("rocords startIndex", startIndex, endIndex, newTotalPages);

            let records

            if (filteredBuyerList.length <= 9) {
                records = filteredBuyerList
            } else {
                records = filteredBuyerList.slice(startIndex, endIndex)
            }

            console.log("rocords response", filteredBuyerList);

            setSellerChargeList(records);
            setTotalPages(Math.ceil(filteredBuyerList.length / 10));
            setTotalRecords([...Array(Math.ceil(filteredBuyerList.length / 10) + 1).keys()].slice(1))
        })

    }

    const allredirectpage = (pathid, status) => {

        if (status === "sold") {

            history.push({
                pathname: "/soldcardetails",
                state: { backURL: "/carlist", id: pathid }
            });
            ls.set("backredirection", [back, "/sellercharges"])
        }
        else {
            history.push({
                pathname: "/cardetails",
                state: { backURL: "/allcars", id: pathid }
            });
            ls.set("backredirection", [back, "/sellercharges"])
        }
    }

    const handleDealer = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setDealerId(value)

    };
    const handleSeller = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setSellerId(value)

    };
    const handleIventory = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, '');
        setInventory(value)

    };

    const handleClick = (item) => {
        if (item.car_id !== 0 && item.car_id !== null && item.car_id !== "" && item.car_id !== "null" && item.car_id !== undefined && item.car_id !== "undefined") {
            allredirectpage(item.car_id, item.carstatus1)
        }
    };

    return (
        <>
            {errorFlag === true ? <PageNotFound error={errors} /> :
                <div>
                    {loading ? <Loading /> :
                        <main id="main" className="inner-page">
                            <section class="section">
                                <div class="container-fluid inner-page-space">
                                    <div class="common-heading">
                                        <div className="row">
                                            <div className="col-lg-4">
                                                <div class="back-btn">
                                                    <a class="back-btn-primary" onClick={() => history.push("/carlist")}>
                                                        <i class="bx bx-chevron-left"></i> Back
                                                    </a>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title">
                                                    <p class="inner-title">Seller Charges</p>
                                                </div>
                                            </div>
                                            <div className="col-lg-4">
                                                <div class="title-dropdown">

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="adduserpageblock col-lg-12">
                                        <div class="sellercharges-search">
                                            <div class="row">
                                                <div class="col-lg-3">
                                                    <div class="sellercharges-search-field-container">
                                                        <div class="row">
                                                            <div class="col-12 border-end">
                                                                <label for="zip" class="form-label mb-0">
                                                                    Dealer #
                                                                </label>
                                                                <input type="text" class="form-control ps-0" placeholder="Enter Dealer #" id="dealerid" value={dealerId} onChange={handleDealer} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-3">
                                                    <div class="sellercharges-search-field-container">
                                                        <div class="row">
                                                            <div class="col-12 border-end">
                                                                <label for="buyerid" class="form-label mb-0">
                                                                    Buyer #
                                                                </label>
                                                                <input type="text" class="form-control ps-0" placeholder="Enter Buyer #" id="buyerid" pattern="[0-9]+" value={sellerId} onChange={handleSeller} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-2">
                                                    <div class="sellercharges-search-field-container">
                                                        <div class="row">
                                                            <div class="col-12 border-end">
                                                                <label for="inventory" class="form-label mb-0">
                                                                    Inventory #
                                                                </label>
                                                                <input type="text" class="form-control ps-0" placeholder="Enter Inventory #" id="inventory" value={inventory} onChange={handleIventory} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-lg-3">
                                                    <div class="sellercharges-search-field-container">
                                                        <div class="row">
                                                            <div class="col-12 border-end">
                                                                <label for="Vin" class="form-label mb-0">
                                                                    VIN #
                                                                </label>
                                                                <input type="text" class="form-control ps-0" placeholder="Enter Vin #" id="Vin" onChange={(e) => setVinNumber(e.target.value)} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-lg-1">
                                                    <div class="sellercharges-search-btn">
                                                        <div class="search-btn">
                                                            <i class="bx bx-search" onClick={() => { searchUser(); setSearchFlag(true) }}></i>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="sellerChargesListtable table-responsive">
                                            <div className="abletable">
                                                <table>
                                                    <thead>
                                                        <tr>
                                                            {/* <th className="">Charges #</th> */}
                                                            <th className="">Inventory #</th>
                                                            <th className="">Image</th>
                                                            <th className="">Vin #</th>
                                                            <th className="">Year</th>
                                                            <th className="">Make</th>
                                                            <th className="">Model</th>
                                                            <th className="">Dealer #</th>
                                                            <th className="">Dealer Name</th>
                                                            <th className="">Seller #</th>
                                                            <th className="">Seller Name</th>
                                                            <th className="">Total Amount</th>
                                                            <th className="">Amount Paid</th>
                                                            <th className="">Amount Due</th>
                                                            <th className="">Date</th>
                                                            <th className="buyercha-action">Action</th>
                                                        </tr>
                                                    </thead>

                                                    {/* {sellerChargeList.length > 0 ? sellerChargeList.map((item) => */}
                                                    {sellerChargeList.length > 0 ? sellerChargeList.map((item) =>

                                                        <tr>
                                                            {/* <td>{item.car_charges_id}</td> */}
                                                            <td class="hyperlink" onClick={() => handleClick(item)}>{item.car_id}</td>
                                                            <td className="userImage"><img alt="" src={item.image === "" || item.image === null ? vehicles : item.image} /></td>
                                                            <td class="hyperlink" onClick={() => handleClick(item)}>{item.vin_no}</td>
                                                            <td>{item.year}</td>
                                                            <td>{item.make}</td>
                                                            <td>{item.model}</td>
                                                            <td class={item?.sellerdealercolor == "pink"
                                                                ? "tableRowPink hyperlink"
                                                                : item?.sellerdealercolor == "Silver"
                                                                    ? "tableRowSilver hyperlink"
                                                                    : item?.sellerdealercolor == "Orange"
                                                                        ? "tableRowOrange hyperlink"
                                                                        : item?.sellerdealercolor == "Navy blue"
                                                                            ? "tableRowNavyBlue hyperlink"
                                                                            : item?.sellerdealercolor == "firered"
                                                                                ? "tableRowFireRed hyperlink"
                                                                                : item?.sellerdealercolor == "Purple"
                                                                                    ? "tableRowPurple hyperlink"
                                                                                    : item?.sellerdealercolor == "Yellow"
                                                                                        ? "tableRowYellow1 hyperlink"
                                                                                        : item?.sellerdealercolor == "green"
                                                                                            ? "tableRowGreenColor hyperlink"
                                                                                            : item?.sellerdealercolor == "blue"
                                                                                                ? "tableRowBlue hyperlink"
                                                                                                : item?.sellerdealercolor == "darkred"
                                                                                                    ? "tableRowRed1 hyperlink"
                                                                                                    : "hyperlink"} onClick={() => { history.push("/manageaccount"); ls.set("backredirection", [...backUrl, "/sellercharges"]) }}>{item.seller_dealer_id}</td>
                                                            <td class={item?.sellerdealercolor == "pink"
                                                                ? "tableRowPink hyperlink"
                                                                : item?.sellerdealercolor == "Silver"
                                                                    ? "tableRowSilver hyperlink"
                                                                    : item?.sellerdealercolor == "Orange"
                                                                        ? "tableRowOrange hyperlink"
                                                                        : item?.sellerdealercolor == "Navy blue"
                                                                            ? "tableRowNavyBlue hyperlink"
                                                                            : item?.sellerdealercolor == "firered"
                                                                                ? "tableRowFireRed hyperlink"
                                                                                : item?.sellerdealercolor == "Purple"
                                                                                    ? "tableRowPurple hyperlink"
                                                                                    : item?.sellerdealercolor == "Yellow"
                                                                                        ? "tableRowYellow1 hyperlink"
                                                                                        : item?.sellerdealercolor == "green"
                                                                                            ? "tableRowGreenColor hyperlink"
                                                                                            : item?.sellerdealercolor == "blue"
                                                                                                ? "tableRowBlue hyperlink"
                                                                                                : item?.sellerdealercolor == "darkred"
                                                                                                    ? "tableRowRed1 hyperlink"
                                                                                                    : "hyperlink"} onClick={() => { history.push("/manageaccount"); ls.set("backredirection", [...backUrl, "/sellercharges"]) }}>{item.dealer_name}</td>
                                                            <td class={item?.sellercolor == "pink"
                                                                ? "tableRowPink hyperlink"
                                                                : item?.sellercolor == "Silver"
                                                                    ? "tableRowSilver hyperlink"
                                                                    : item?.sellercolor == "Orange"
                                                                        ? "tableRowOrange hyperlink"
                                                                        : item?.sellercolor == "Navy blue"
                                                                            ? "tableRowNavyBlue hyperlink"
                                                                            : item?.sellercolor == "firered"
                                                                                ? "tableRowFireRed hyperlink"
                                                                                : item?.sellercolor == "Purple"
                                                                                    ? "tableRowPurple hyperlink"
                                                                                    : item?.sellercolor == "Yellow"
                                                                                        ? "tableRowYellow1 hyperlink"
                                                                                        : item?.sellercolor == "green"
                                                                                            ? "tableRowGreenColor hyperlink"
                                                                                            : item?.sellercolor == "blue"
                                                                                                ? "tableRowBlue hyperlink"
                                                                                                : item?.sellercolor == "darkred"
                                                                                                    ? "tableRowRed1 hyperlink"
                                                                                                    : "hyperlink"} onClick={() => { history.push("/myprofile"); ls.set("backredirection", [...backUrl, "/sellercharges"]) }}>{item.seller_id}</td>
                                                            <td class={item?.sellercolor == "pink"
                                                                ? "tableRowPink hyperlink"
                                                                : item?.sellercolor == "Silver"
                                                                    ? "tableRowSilver hyperlink"
                                                                    : item?.sellercolor == "Orange"
                                                                        ? "tableRowOrange hyperlink"
                                                                        : item?.sellercolor == "Navy blue"
                                                                            ? "tableRowNavyBlue hyperlink"
                                                                            : item?.sellercolor == "firered"
                                                                                ? "tableRowFireRed hyperlink"
                                                                                : item?.sellercolor == "Purple"
                                                                                    ? "tableRowPurple hyperlink"
                                                                                    : item?.sellercolor == "Yellow"
                                                                                        ? "tableRowYellow1 hyperlink"
                                                                                        : item?.sellercolor == "green"
                                                                                            ? "tableRowGreenColor hyperlink"
                                                                                            : item?.sellercolor == "blue"
                                                                                                ? "tableRowBlue hyperlink"
                                                                                                : item?.sellercolor == "darkred"
                                                                                                    ? "tableRowRed1 hyperlink"
                                                                                                    : "hyperlink"} onClick={() => { history.push("/myprofile"); ls.set("backredirection", [...backUrl, "/sellercharges"]) }}>{item.sellername}</td>
                                                            <td>{item.amount_due}</td>
                                                            <td>{item.amount_paid}</td>
                                                            <td>{item.balence_due}</td>
                                                            <td>{item.charges_date}</td>
                                                            <td className='action-right-fix-list' >
                                                                <Button className="ant-btn" onClick={() => onHandleView(item)}> View</Button>
                                                            </td>


                                                        </tr>
                                                    ) :
                                                        <tr>
                                                            <td colspan="13" ng-show="0"><b>There's No Data</b></td>
                                                        </tr>
                                                    }

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div className="col-lg-12 tablePagination d-flex justify-content-center">
                                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} totalRecords={totalRecords} handlePages={handlePages} />
                            </div>
                            {/* <div className="col-lg-12 tablePagination d-flex justify-content-center pageul">
                        <Pagination className=""
                            totalRecords={totalRecords}
                            pageLimit={pageLimit}
                            pageRangeDisplayed={1}
                            onChangePage={setCurrentPage}
                        />
                    </div> */}
                            <section id="playstoreBlock" className="playstoreBlock">
                                <div className="container">


                                    <div className="row content">
                                        <div className="col-lg-12">
                                            <img src={appstore} />
                                            <img src={googleplay} />
                                        </div>

                                    </div>

                                </div>
                            </section>

                        </main>}

                </div>}
        </>
    );
};



export default SellerCharges;